"use strict";
/**
 * Convert `RGB` to `#rgb`
 * JavaScript note: no check for array length, use it properly.
 */
function rgbHex(rgb) {
    var hex = '#';
    for (var i = 0; i < 3; i++) {
        hex += d2h(rgb[i]);
    }
    return hex;
}
exports.rgbHex = rgbHex;
function d2h(d) {
    var s = (+d).toString(16);
    return s.length < 2 ? '0' + s : s;
}
//# sourceMappingURL=rgbHex.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rainbow-color/node_modules/color-map/dist/commonjs/rgbHex.js
// module id = 1874
// module chunks = 0